import { DurationService } from '@mews/framework/datetime';

export const isEndOffsetNegative = (endOffset: string) => {
    const duration = DurationService.parse(endOffset);
    return DurationService.isNegative(duration);
};
